<template>
  <div class="tab">
    <div class="page__bd" style="height: 100%;">
      <div class="weui-tab">
        <div class="weui-tabbar">
          <a
            href="javascript:;"
            class="weui-tabbar__item"
            v-for="(item, index) in tabs"
            :key="index"
            :class="curr==item.label?'weui-bar__item_on':''"
            @click="goto(item)"
          >
            <span style="display: inline-block;position: relative;">
              <img :src="curr==item.label?item.imgSelected:item.img" alt class="weui-tabbar__icon">
              <span class="weui-badge weui-badge_dot" style="position: absolute;top: 0;right: -6px;" v-if="index==1 && curr!=item.label"></span>
            </span>
            <p class="weui-tabbar__label">{{item.label}}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";

export default {
  props: {
    curr: String,
    token: String
  },
  data() {
    return {
      currTab: {},
      tabs: [
        {
          label: "首页",
          link: "/home/" + this.token,
          img: "/static/shouye-0.png",
          imgSelected: "/static/shouye-1.png"
        },
        // {
        //   label: "发现",
        //   link: "/circleDiscovery/" + this.token,
        //   img: "/static/faxian-0.png",
        //   imgSelected: "/static/faxian-1.png"
        // },
        {
          label: "客服",
          link: "/serviceHelp/" + this.token,
          img: "/static/kefu-0.png",
          imgSelected: "/static/kefu-1.png"
        },
        {
          label: "我的",
          link: "/my/" + this.token,
          img: "/static/wode-0.png",
          imgSelected: "/static/wode-1.png"
        }
      ]
    };
  },
  created() {
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.curr == this.tabs[i].label) {
        this.currTab = this.tabs[i];
        break;
      }
    }
  },
  methods: {
    goto(item) {
      if (this.curr != item.label) {
        this.$router.push(item.link);
      }
    }
  }
};
</script>

<style>
.weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon,
.weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon > i,
.weui-tabbar__item.weui-bar__item_on .weui-tabbar__label {
  color: #feb70f;
}
</style>

<style scoped>
div.tab {
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/home/Tab.vue